<template>
  <div>
    <banner :equipmentCount='equipmentCount'></banner>
    <div class='SDAU_style eq_body'>
      <div class='eq_header'>
        <h1 style='font-size:36px'>仪器设备展示</h1>
        <span style='font-size: 14px;font-family: Arial;color: #666666;'>Instruments and
          equipment</span>
        <el-row class='line' style='width: 888px;'>
          <el-col style='height:10px;border-bottom:1px #D7DCE0 solid' :span='11'>
          </el-col>
          <el-col style='height:10px;border-bottom:8px #188335 solid;margin-top:4px' :span='2'>
          </el-col>
          <el-col style='height:10px;border-bottom:1px #D7DCE0 solid' :span='11'>
          </el-col>
        </el-row>
      </div>

      <div class='eq_select'>
        <!-- <div style='position: absolute; top: 52px;left: 60px;'><el-button style="font-size:18px"
            type='text' @click='e_reset'>重置</el-button>
        </div> -->
        <div class='select_tabbox'>
          <div class='tabtitle'>
            实验室分类
          </div>
          <el-tabs class='flexStyle' v-model="Laboratory" @tab-click="LaboratoryChange" :before-leave='ifcancelarea'>
            <el-tab-pane v-for='(item, index) in areaList' :key='index + item.id' :label="item.areaName"
              :name="String(item.id)"></el-tab-pane>
            <!-- <el-tab-pane label="实验室2" name="second"></el-tab-pane>
            <el-tab-pane label="实验室3" name="third"></el-tab-pane>
            <el-tab-pane label="实验室4" name="four"></el-tab-pane> -->
          </el-tabs>
        </div>
        <div class='select_tabbox'>
          <div class='tabtitle'>
            设备分类
          </div>
          <el-tabs class='flexStyle' v-model="eqment" @tab-click="eqmentChange" :before-leave='ifcanceltype'>
            <el-tab-pane v-for='(item, index) in typeList' :key='index + item.id' :label="item.nodeName"
              :name="String(item.id)"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class='eq_msg'>
        <div v-for='(item, index) in showEqlist' :key='index + String(item.id)' class='eq_card'>
          <img id="imghw" v-if='item.thumbnailPath' style="width: 35%;" :src="baseurl + '/' + item.thumbnailPath">
          <img id="imghw" v-if='!item.thumbnailPath' style="width: 35%;" src="../assets/images/img_blank.png">
          <div style="width: 50%;margin-left:43px;display:inline-block;">
            <h3 style="margin-bottom:16px">{{ item.equipmentName }}</h3>
            <p>所属类别：色谱仪</p>
            <p>设备管理员：{{ item.mainUserName }}</p>
            <p>规格型号：{{ item.equipmentModel }}</p>
            <p>联系方式：{{ item.mainUserPhone }}</p>
            <div style='padding-top: 12px;display:flex;justify-content: space-between;width: 200px;'>
              <el-button @click='moreMsg(item)'>更多信息</el-button>
            </div>
          </div>
        </div>
        <div style='width: 100%;display:flex;justify-content: center;margin:40px 0 48px 0'>
          <img @click='goEqment' style="cursor: pointer;" src="../assets/images/btn_more.png">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { APIURl } = require('@/utils/apiUrl')
export default {
  data() {
    return {
      Laboratory: undefined,
      eqment: undefined,
      equipmentCount: '',
      typeList: [],
      areaList: [],
      showEqlist: [],
      baseurl: '',
      ifarea: false,
      iftype: false,
    }
  },
  methods: {
    init() {
      this.baseurl = APIURl
      this.$net('/v1/userClient/home/initHomeData', 'get').then(res => {
        this.equipmentCount = res.data.equipmentCount
        this.areaList = res.data.areaList
        this.typeList = res.data.treeList
        let data = {
          equipmentAreaId: '',
          treeId: ''
        }
        this.geteqList(data)
      })
    },
    ifcancelarea() {
      this.ifarea = true
    },
    ifcanceltype() {
      this.iftype = true
    },
    LaboratoryChange() {
      !this.ifarea ? this.Laboratory = '' : null
      this.eqswitch()
      this.ifarea = false
    },
    eqmentChange() {
      !this.iftype ? this.eqment = '' : null
      this.eqswitch()
      this.iftype = false
    },
    eqswitch() {
      if (this.eqment == '0') {
        this.eqment = ''
      }
      if (this.Laboratory == '0') {
        this.Laboratory = ''

      }
      let data = {
        equipmentAreaId: this.Laboratory,
        treeId: this.eqment
      }
      this.geteqList(data)
    },
    geteqList(data) {
      this.$net('/v1/userClient/home/queryAllHomeEquipmentList', 'get', data).then(res => {
        this.showEqlist = res.data
        if (this.showEqlist.length > 10) {
          this.showEqlist = this.showEqlist.splice(0, 10)
        }
      })
    },
    goEqment() {
      this.$router.push({ path: '/eqment' })
    },
    toDetail(item) {
      this.$net(`/v1/billing/scheme/querySchemeByEquipmentId/${item.id}`, 'get').then(res => {
        this.$router.push({
          path: '/appointment',
          query: {
            id: item.id,
            billingMethod: res.data.billingMethod
          }
        })
      })
    },
    moreMsg(item) {
      this.$router.push({
        path: '/eqmentappointmentmsg',
        query: {
          id: item.id
        }
      })
    },
    resetimgHeight() {
      if (this.$route.path != '/') {
        window.removeEventListener('resize', this.resetimgHeight, false);
        return
      }
      var img_ls = document.getElementsByTagName('img')
      for (var i = 0; i < img_ls.length; i++) {
        if (img_ls[i].getAttribute('id') == 'imghw') {
          img_ls[i].style.height = img_ls[i].offsetWidth + 'px'
        }
      }

    },
  },
  created() {
    this.init()
  },
  mounted() {
    window.addEventListener('resize', this.resetimgHeight);
  },
  updated() {
    this.resetimgHeight();
  },

};
</script>
<style scoped lang="scss">
::v-deep.eq_body {
  margin-top: 80px;
  height: auto;

  .el-tabs__active-bar {
    background-color: transparent !important;
  }

  /*去掉tabs底部的下划线*/
  .el-tabs__nav-wrap::after {
    position: static !important;
  }

  .el-tabs__item {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #666666;
  }

  .el-tabs__nav .el-tabs__item:not(:last-child) {
    border-right: 1px #d7dce0 solid;
  }

  .el-tabs__nav .el-tabs__item:nth-child(2) {
    padding-left: 20px;
  }

  .el-tabs__nav .el-tabs__item:last-child {
    padding-right: 20px;
  }

  .el-tabs__item.is-active {
    background: #188335;
    color: #ffffff;
  }

  .eq_header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 130px;
    cursor: default;
    margin-bottom: 48px;
  }

  .eq_select {
    height: 144px;
    margin: 52px 0 32px 0;
    background: #ffffff;
    position: relative;
    width: 100%;

    .select_tabbox {
      width: 100%;
      height: 72px;
      line-height: 48px;
      padding: 16px 20px 8px 0;

      // display: flex;
      // justify-content: start;
      .flexStyle {
        width: calc(100% - 200px);
        float: left;
        overflow-x: scroll;
        overflow-y: hidden;
      }

      ::-webkit-scrollbar {
        /* 隐藏滚动条 */
        display: none;
      }

      .tabtitle {
        width: 150px;
        float: left;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #333333;
        text-align: right;
        margin-right: 40px;
      }
    }
  }

  .eq_msg {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .eq_card {
      width: 48%;
      height: auto;
      padding: 25px 0 25px 44px;
      background: #ffffff;
      border: 1px #d7dce0 solid;
      margin-bottom: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        margin-bottom: 8px;
        color: #333333;
        font-size: 14px;
      }
    }
  }
}
</style>
